// extracted by mini-css-extract-plugin
module.exports = {"container":"_a6a77089","itemContainer":"_1e4830fc","imageWrapper":"_bef00d1a","title":"_2da2c0ae","image":"_ab4df4a9","shimmerLoadingBackground":"_c7f3d0c3"};